import $ from '@vaersaagod/tools/Dom';
import Dispatch from '@vaersaagod/tools/Dispatch';
import Viewport from '@vaersaagod/tools/Viewport';
import * as Events from '../lib/events';

const OFFSET_TOP_UP = 0;
const OFFSET_TOP_DOWN = 100;
const OFFSET_BUFFER = 20;

const loadLottie = require('bundle-loader?lazy&name=[name]!lottie-web');

export default el => {
    const dom = $(el);
    const html = $('html');
    const body = $('body');
    const logo = dom.find('[data-logo]').get(0);
    const logoShape = dom.find('[data-logo] .shape').get(0);
    const logoCanvas = dom.find('[data-logo-canvas]').get(0);
    const search = dom.find('[data-search]');
    const searchOpen = search.find('g').get(0);
    const searchClose = search.find('g').get(1);
    const hamburger = dom.find('[data-hamburger]');
    const hamburgerTop = hamburger.find('path:nth-of-type(1)').get(0);
    const hamburgerMiddle = hamburger.find('path:nth-of-type(2)').get(0);
    const hamburgerBottom = hamburger.find('path:nth-of-type(3)').get(0);

    let logoAnim = false;
    let logoDelay = 0;
    let isActive = true;
    let isHidden = false;
    let isSolid = false;
    let isCollapsed = false;
    let isMenuOpen = false;
    let isSearchOpen = false;
    let lastTop = 0;

    const hamburgerToX = () => {
        const offset = 7;
        TweenLite.to(logo, 0.3, { opacity: 0, ease: Sine.easeIn });
        TweenLite.to(hamburgerTop, 0.15, { y: offset, ease: Sine.easeIn });
        TweenLite.to(hamburgerBottom, 0.15, {
            y: offset * -1,
            ease: Sine.easeIn,
            onComplete: () => {
                TweenLite.set(hamburgerMiddle, { opacity: 0 });
                TweenLite.to(hamburgerTop, 0.2, { rotationZ: '45deg', transformOrigin: '50% 50%', ease: Quart.easeOut });
                TweenLite.to(hamburgerBottom, 0.2, { rotationZ: '-45deg', transformOrigin: '50% 50%', ease: Quart.easeOut });
            }
        });
    };

    const xToHamburger = () => {
        TweenLite.to(logo, 0.2, { opacity: 1, ease: Sine.easeOut });
        TweenLite.to(hamburgerTop, 0.1, { rotationZ: '0deg', transformOrigin: '50% 50%', ease: Sine.easeIn });
        TweenLite.to(hamburgerBottom, 0.1, {
            rotationZ: '0deg',
            transformOrigin: '50% 50%',
            ease: Sine.easeIn,
            onComplete: () => {
                TweenLite.set(hamburgerMiddle, { opacity: 1 });
                TweenLite.to(hamburgerTop, 0.15, { y: 0, ease: Quart.easeOut, clearProps: 'all' });
                TweenLite.to(hamburgerBottom, 0.15, { y: 0, ease: Quart.easeOut, clearProps: 'all' });
            }
        });
    };

    const searchToX = () => {
        TweenLite.to(searchOpen, 0.4, { opacity: 0, rotationZ: '90deg', transformOrigin: '50% 50%', ease: Quart.easeInOut });
        TweenLite.to(searchClose, 0.4, { opacity: 1, rotationZ: '0deg', transformOrigin: '50% 50%', ease: Quart.easeInOut });
    };

    const xToSearch = () => {
        TweenLite.to(searchOpen, 0.4, { opacity: 1, rotationZ: '0deg', transformOrigin: '50% 50%', ease: Quart.easeInOut });
        TweenLite.to(searchClose, 0.4, { opacity: 0, rotationZ: '-90deg', transformOrigin: '50% 50%', ease: Quart.easeInOut });
    };

    const activate = key => {
        if (key === Events.MENU_CLOSE) {
            isMenuOpen = false;
            hamburger.attr('aria-label', 'Open Menu');
            xToHamburger();
        } else if (key === Events.SEARCH_CLOSE) {
            isSearchOpen = false;
            search.attr('aria-label', 'Open Search');
            xToSearch();
        }
        setTimeout(() => {
            isActive = true;
            dom.removeClass('light');
            if (lastTop > OFFSET_TOP_DOWN) {
                solid();
            }
        }, 50);
    };

    const deactivate = key => {
        isActive = false;
        transparent();
        dom.addClass('light');
        if (key === Events.MENU_OPEN) {
            isMenuOpen = true;
            hamburger.attr('aria-label', 'Close Menu');
            hamburgerToX();
        } else if (key === Events.SEARCH_OPEN) {
            isSearchOpen = true;
            search.attr('aria-label', 'Close Search');
            searchToX();
        }
    };

    const show = () => {
        if (isActive && isHidden) {
            isHidden = false;
            TweenLite.killTweensOf(el);
            TweenLite.to(el, 0.5, { yPercent: '0%', ease: Quad.easeOut });
        }
    };

    const hide = () => {
        if (isActive && !isHidden) {
            isHidden = true;
            TweenLite.killTweensOf(el);
            TweenLite.to(el, 0.5, {
                yPercent: '-100%',
                ease: Quad.easeOut,
                onComplete: () => {
                    isCollapsed = true;
                    dom.addClass('collapsed');
                    isSolid = true;
                    dom.addClass('solid');
                }
            });
        }
    };

    const expand = () => {
        if (isCollapsed) {
            isCollapsed = false;
            dom.removeClass('collapsed');
        }
    };

    const transparent = () => {
        if (isSolid) {
            isSolid = false;
            dom.removeClass('solid');
        }
    };

    const solid = () => {
        if (!isSolid) {
            isSolid = true;
            dom.addClass('solid');
        }
    };

    const cancelScroll = () => body.hasClass('featured') && Viewport.width >= 1200;

    const scrollHandler = () => {
        if (cancelScroll()) {
            return;
        }
        const scrollTop = Viewport.scrollTop;
        if (Math.abs(scrollTop - lastTop) > OFFSET_BUFFER) {
            const isScrollingUp = scrollTop < lastTop;

            if (isActive) {
                if (isScrollingUp) {
                    show();
                    if (scrollTop < OFFSET_TOP_DOWN) {
                        expand();
                        transparent();
                    }
                } else if (scrollTop > OFFSET_TOP_UP) {
                    hide();
                }
            }
            lastTop = scrollTop;
        }
    };

    const hideIfPageScrolled = () => {
        if (cancelScroll()) {
            return;
        }
        if (html.hasClass('scrolled') || Viewport.scrollTop > 0) {
            isHidden = true;
            isSolid = true;
            isCollapsed = true;
            dom.addClass('collapsed solid');
            dom.css('transform', 'none');
            TweenLite.set(el, { yPercent: '-100%' });
        }
    };

    const animateLogo = delay => {
        clearTimeout(logoDelay);
        logoDelay = setTimeout(() => {
            logoAnim.play();
            setTimeout(() => {
                logoAnim.pause();
            }, 2000);
            animateLogo(10000);
        }, delay);
    };

    const init = () => {
        search.on('click', e => {
            e.preventDefault();
            if (body.hasClass('is-search')) {
                $('#query_page').focus();
            } else if (isMenuOpen) {
                Dispatch.emit(Events.MENU_CLOSE);
                Dispatch.emit(Events.SEARCH_OPEN);
            } else {
                Dispatch.emit(isSearchOpen ? Events.SEARCH_CLOSE : Events.SEARCH_OPEN);
            }
        });

        hamburger.on('click', e => {
            e.preventDefault();
            if (isSearchOpen) {
                Dispatch.emit(Events.SEARCH_CLOSE);
                Dispatch.emit(Events.MENU_OPEN);
            } else {
                Dispatch.emit(isMenuOpen ? Events.MENU_CLOSE : Events.MENU_OPEN);
            }
        });

        TweenLite.set(searchClose, { opacity: 0, rotationZ: '-90deg', transformOrigin: '50% 50%' });

        dom.on('focusin', show);
        Dispatch.on(Events.MENU_OPEN, deactivate);
        Dispatch.on(Events.MENU_CLOSE, activate);
        Dispatch.on(Events.MODAL_OPEN, deactivate);
        Dispatch.on(Events.MODAL_CLOSE, activate);
        Dispatch.on(Events.SEARCH_OPEN, deactivate);
        Dispatch.on(Events.SEARCH_CLOSE, activate);
        Viewport.on('scroll', scrollHandler);

        loadLottie(lottie => {
            logoAnim = lottie.loadAnimation({
                container: logoCanvas,
                renderer: 'svg',
                loop: true,
                autoplay: false,
                path: '/logo.json'
            });
            logoAnim.addEventListener('DOMLoaded', () => {
                TweenLite.to(logoShape, 0.3, { opacity: 0, ease: Sine.easeOut });
                TweenLite.to(logoCanvas, 0.3, { opacity: 1, ease: Sine.easeOut });
            });
            animateLogo(5000);
        });

        hideIfPageScrolled();
    };

    const destroy = () => {
        dom.off('focusin');
        hamburger.off('click');
        search.off('click');
        Viewport.off('scroll', scrollHandler);
        Dispatch.off(Events.MENU_OPEN, deactivate);
        Dispatch.off(Events.MENU_CLOSE, activate);
        Dispatch.off(Events.MODAL_OPEN, deactivate);
        Dispatch.off(Events.MODAL_CLOSE, activate);
        Dispatch.off(Events.SEARCH_OPEN, deactivate);
        Dispatch.off(Events.SEARCH_CLOSE, activate);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Header.js